import React from "react"
import {Form, Box, Columns, Heading, Button} from "react-bulma-components";

export const OnHireSection = ({rental, onChange}) => {

  return (
    <Box>
      <Heading>On Hire</Heading>
      <Columns>
          <Columns.Column>
              <Form.Field className="has-addons">
                <Form.Control>
                  <Form.Label>Our Insurance</Form.Label>
                  <Button
                    color={rental.on_hire_insurance_completed === "NOT_REQUIRED"  ? "primary" : ""}
                    onClick={() => onChange({target: {name: "on_hire_insurance_completed", value: "NOT_REQUIRED"}})}
                  >
                    Not Required
                  </Button>
                  <Button
                    color={rental.on_hire_insurance_completed === "NOT_DONE"  ? "danger" : ""}
                    onClick={() => onChange({target: {name: "on_hire_insurance_completed", value: "NOT_DONE"}})}
                  >
                    Not Done
                  </Button>
                  <Button
                    color={rental.on_hire_insurance_completed === "COMPLETE" ? "success" : ""}
                    onClick={() => onChange({target: {name: "on_hire_insurance_completed", value: "COMPLETE"}})}
                  >
                    Complete
                  </Button>
                </Form.Control>
              </Form.Field>
          </Columns.Column>
          <Columns.Column>
              <Form.Field className="has-addons">
                <Form.Control>
                  <Form.Label>Tracker Access</Form.Label>
                  <Button
                    color={rental.on_hire_tracker_completed === "NOT_REQUIRED"  ? "primary" : ""}
                    onClick={() => onChange({target: {name: "on_hire_tracker_completed", value: "NOT_REQUIRED"}})}
                  >
                    Not Required
                  </Button>
                  <Button
                    color={rental.on_hire_tracker_completed === "NOT_DONE"  ? "danger" : ""}
                    onClick={() => onChange({target: {name: "on_hire_tracker_completed", value: "NOT_DONE"}})}
                  >
                    Not Done
                  </Button>
                  <Button
                    color={rental.on_hire_tracker_completed === "COMPLETE" ? "success" : ""}
                    onClick={() => onChange({target: {name: "on_hire_tracker_completed", value: "COMPLETE"}})}
                  >
                    Complete
                  </Button>
                </Form.Control>
              </Form.Field>
          </Columns.Column>
          <Columns.Column>
              <Form.Field className="has-addons">
                <Form.Control>
                  <Form.Label>Key Unassigned</Form.Label>
                  <Button
                    color={rental.key_unassigned  ? "" : "danger"}
                    onClick={() => onChange({target: {name: "key_unassigned", value: false}})}
                  >
                    Assigned
                  </Button>
                  <Button
                    color={rental.key_unassigned ? "success" : ""}
                    onClick={() => onChange({target: {name: "key_unassigned", value: true}})}
                  >
                    Unassigned
                  </Button>
                </Form.Control>
              </Form.Field>
          </Columns.Column>
        </Columns>
        <Columns>
            <Columns.Column>
                <Form.Label>Order Number</Form.Label>
                <Form.Input
                    type={"text"}
                    name={"order_number"}
                    onChange={onChange}
                    value={rental.order_number}
                />
            </Columns.Column>
            <Columns.Column>
                <Form.Label>Vehicle Collected / Delivered</Form.Label>
                <Form.Checkbox
                    name={"vehicle_collected"}
                    checked={rental.vehicle_collected}
                    onChange={() => onChange({target: {name: "vehicle_collected", value:!rental.vehicle.collected}})}
                />
            </Columns.Column>
            <Columns.Column>
                <Form.Label>On Hire Time</Form.Label>
                <Form.Input
                    type={"time"}
                    value={rental.on_hire_time}
                    onChange={onChange}
                    name={"on_hire_time"}
                />
            </Columns.Column>
        </Columns>
        <Columns>
            <Columns.Column>
                <Form.Label>Internal Comments (Will not appear on contract)</Form.Label>
                <Form.Textarea
                    name={"comments"}
                    onChange={onChange}
                    value={rental.comments}
                />
            </Columns.Column>
            <Columns.Column>
                <Form.Label>Contract Comments</Form.Label>
                <Form.Textarea
                    name={"contract_comments"}
                    onChange={onChange}
                    value={rental.contract_comments}
                />
            </Columns.Column>
        </Columns>
    </Box>
  )
}